import React, { Suspense } from "react";

import { IHeaderProps } from "../Header";

export const LazyMobileHeader: React.FC<IHeaderProps> = ({ search, menu }) => {
  return (
    <Suspense fallback={null}>
      <LazyMobileHeaderBase search={search} menu={menu} />
    </Suspense>
  );
};

const LazyMobileHeaderBase = React.lazy<React.ComponentType<IHeaderProps>>(() =>
  import(
    /* webpackChunkName: "help-center-mobile-header" */ "./MobileHeader"
  ).then((module) => {
    return {
      default: module.MobileHeader,
    };
  })
);
